import { render, staticRenderFns } from "./BrokersList.vue?vue&type=template&id=3f010c9a"
import script from "./BrokersList.vue?vue&type=script&lang=js"
export * from "./BrokersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports